"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchEmbedCodes = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'filemanager/api/v3/players';

var fetchEmbedCodes = function fetchEmbedCodes(playerId) {
  return _apiClient.default.get(BASE_URI + "/" + playerId + "/embed-codes").then(function (embedCode) {
    return embedCode.url;
  });
};

exports.fetchEmbedCodes = fetchEmbedCodes;